export default __webpack_public_path__ + "6f6331c.png";